<template>
  <div class="">
    <div class="">
      <section class="content-header welcomesc pt-s-5">
        <custom-alert v-if="displayMissingMemFields==true" :message="alertMessage" v-on:showedAlert="resetAlert"></custom-alert>
        <div :style="{ backgroundImage: `url(${this.dashboardWelcomeContent.image!=undefined?this.basePath+this.dashboardWelcomeContent.image:subdomain=='waterski'?'':'/dist/img/profile/banner.png'})` }" class="renewalsection">
          <div class="row">
            <div class="col-md-2  col-xs-2 col-sm-2 m-dash-logo" v-if="this.getSiteProps('member.logo') == undefined">
              <img
                  :src="'/' + this.getSiteProps('login.logo')"
                  v-if="'/' + this.getSiteProps('login.logo')"
              />
            </div>
            <div class="col-md-2  col-xs-2 col-sm-2 m-dash-logo" v-else>
              <img
                  :src="'/' + this.getSiteProps('member.logo')"
                  v-if="'/' + this.getSiteProps('member.logo')"
              />
            </div>
            <div class="col-md-7">
              <h3 class="renew-title">{{dashboardWelcomeContent.title}}</h3>
              <span class="renew-subtitle"
              >{{dashboardWelcomeContent.content}}</span
              >
            </div>
            <div class="col-md-3">
              <div class="right" style="text-align: center; margin-bottom: 10px; padding: 8px;" v-show="digitalInfoView" v-if="(profileData.info.membership && profileData.info.membership.period != 999) && profileData.info.personal_details.relation == 0 && profileData.info.membership.auto_renew">
                <div :class="subdomain=='waterski'? 'autorenewal dashboardrenewal':'autorenewal'">
                  <AutoRenewalButton :page="page" :profileData="profileData" :autoRenew="autoRenew" :autoRenewData="autoRenewData" @loadMembersInfo="loadMembersInfo" />
                </div>
              </div>
              <!-- ChildCompon -->
              <button
                  type="button"
                  class="btn btn-primary btn-renew"
                  @click="renewMemberShip"
                  v-if="(profileData.info.canUpgrade || membershipExpiring)"
              >
                <!--                v-if="profileData.info.membership_expiring"-->
                <i class="fas fa-sync-alt"></i> {{ renewalUpgradeText }}
              </button>
            </div>
          </div>
        </div>
      </section>

      <div class="video-wrapper admindash-widget">
        <custom-alert
            v-if="displayAlert == true"
            :message="alertMessage"
            v-on:showedAlert="resetAlert"
        ></custom-alert>
        <div class="row mb-3">
          <div class="col-md-3 col-sm-6 col-12 r-pad l-pad">
            <div class="info-box bg-gradient-info shadow-sm">
              <span class="info-box-icon"><i class="fas fa-user"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Membership Number </span>
                <span class="info-box-number">{{
                    profileData.info.confirmation_code
                  }}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>


          <div class="col-md-3 col-sm-6 col-12 r-pad l-pad ">
            <div class="info-box bg-gradient-success shadow-sm">
              <span class="info-box-icon"
              ><i class="far fa-address-card"></i
              ></span>

              <div class="info-box-content">
                <span class="info-box-text">Member Type</span>
                <span class="info-box-number">{{
                    profileData.info.membership.name
                  }}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>

          <div class="col-md-3 col-sm-6 col-12 r-pad l-pad " >
            <div class="info-box bg-gradient-warning shadow-sm">
              <span class="info-box-icon"
              ><i class="far fa-calendar-alt"></i
              ></span>

              <div class="info-box-content">
                <span class="info-box-text">Expiration Date </span>
                <span class="info-box-number">{{
                    profileData.info.membership.period != 999 ? usdate(profileData.info.membership_endtate) : 'No Expiration'
                  }}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>

          <div class="col-md-3 col-sm-6 col-12 r-pad l-pad">
            <div class="info-box bg-gradient-gray shadow-sm">
              <span class="info-box-icon"
              ><i class="fas fa-clipboard-check"></i
              ></span>

              <div class="info-box-content">
                <span class="info-box-text">Membership Status
                  <template v-if="profileData.info.membership.id !=13 && profileData.info.membership.member_type_id !=5" ><div class="d-inline ml-2" id="tooltip" v-if="subdomain == 'waterski'"><i class="fas fa-info-circle"></i></div><b-tooltip target="tooltip" class="white">{{profileData.info.membership_status_info}} <br> Click here to review all Membership Statuses - <a href="https://www.usawaterski.org/membership" target="_blank">https://www.usawaterski.org/membership</a></b-tooltip></template></span>
                <span class="info-box-number float-left mr-1">{{ profileData.info.membership_status_text }}</span>
                <b-badge variant="secondary" class="ml-1 mt-1 float-left" v-if="this.profileData.info.membership_status === 5
                  && this.profileData.info.personal.relation < 2
                  && this.profileData.info.membership.name !== 'Supporting'">
                  <b-link v-b-modal.signSpouseWaiver class="text-white" >Sign now</b-link>
                </b-badge>
                <div class="btn-primary btn trnow"  v-if="this.profileData.info.membership_status == 4 ">
                  <router-link variant="secondary"  class="text-white" to="/member/safesports">Complete Training Now</router-link>
                </div>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
        </div>
        <div class="row memberdashboard-widgets shopnow image">
          <div class="col-md-6 r-pad l-pad">
            <div class="position-relative" v-if="dashboardBannerStatus">
              <a :href="linkToPage" target="_blank">
              <img class="img-fluid" :src="basePath+dashboardBannerContent.image" v-if="dashboardBannerContent.image"> </a>
              <div class="overlaycstext imageContent dashboardimage card rounded-0">
                  <div class="text-dark mb-0"  v-html="dashboardBannerContent.content">
                  </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 l-pad pr-0">
            <div class="row">
              <div class="col-md-6 r-pad l-pad mb-1 pl-0" :class="profileData.info.membership.id == 13 || profileData.info.membership.member_type_id == 5 || profileData.info.membership.member_type_id == 7? 'gray-out-link' : ''" v-if="subdomain == 'waterski'&&profileData.info.membership.member_type_id != 7">
                <div
                    class="border-wrapper  shadow-sm bg_blue bg-white"
                    :class="
                    profileData.info.safe_sport.safe_sport_status == 0
                      ? 'border-danger'
                      : 'border-green'
                  "
                >
                  <div class="border-text mb-1">
                    <h4> Safe Sport Status</h4>
                    <span v-if="safeSportApiCall == false">{{ safeSportRefreshButton }}</span>
                    <span v-else>
                      {{ profileData.info.safe_sport.safe_sport_status_text || "N/A" }}
                      <template v-if="profileData.info.safe_sport.safe_sport_status == 13 && profileData.info.safe_sport.expiration">
                        (On {{ profileData.info.safe_sport.expiration }})
                      </template>
                      <template v-if="profileData.info.safe_sport.safe_sport_status == 3 && profileData.info.safe_sport.expiration">
                        (Expires {{ profileData.info.safe_sport.expiration }})
                      </template>
                    </span>
                  </div>
                  <div v-if="profileData.info.safe_sport.safe_sport_status == 0" class="border-icon">
                    <span class="info-box-icon"
                    ><i class="far fa-times-circle"></i
                    ></span>
                  </div>
                  <div v-if="profileData.info.safe_sport.safe_sport_status == 1" class="border-icon">
                    <span class="info-box-icon"
                    ><i class="far fa-clock text-warning"></i></span>
                  </div>
                  <div v-if="profileData.info.safe_sport.safe_sport_status == 3" class="border-icon">
                    <span class="info-box-icon"
                    ><i class="far fa-check-circle"></i></span>
                  </div>
                  <div v-if="profileData.info.safe_sport.safe_sport_status == 13" class="border-icon">
                    <span class="info-box-icon"
                    ><i class="far fa-calendar-times text-danger"></i></span>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-6 r-pad l-pad mb-1" v-if="subdomain != 'shooting'">
                <div class="border-wrapper border-yellow shadow-sm">
                  <div class="border-text">
                    <h4>Background Screen Status</h4>
                    <span class=""> Pending </span>
                  </div>
                  <div class="border-icon">
                    <span class="info-box-icon"
                      ><i class="fas fa-sync-alt"></i
                    ></span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-6 r-pad l-pad mb-1" :class="profileData.info.membership.id == 13 || profileData.info.membership.member_type_id == 5 ? 'gray-out-link' : ''" v-if="subdomain == 'waterski'&&profileData.info.membership.member_type_id != 7">
                <div  v-if="ignoreWaiverMembership.includes(profileData.info.membership.id)" class="border-wrapper  shadow-sm bg_blue bg-white">
                  <div class="border-text mb-1">
                    <h4>Waiver Status</h4>
                    <span>N/A</span>
                  </div>
                </div>
                <div  v-else-if="profileData.info.waiver_status ==1" class="border-wrapper  shadow-sm bg_blue bg-white">
                  <div class="border-text mb-1">
                    <h4>Waiver Status</h4>
                    <span class="text-success">Signed</span>
                  </div>
                  <div class="border-icon">
                    <template>
                      <div class="" id="tooltip1"><i class="fas fa-info-circle"></i></div>
                      <b-tooltip target="tooltip1" class="white">
                        <span v-if="profileData.info.waiver_status ==1"> Signed</span>
                        <span v-if="profileData.info.waiver_status ==0"> Not Signed</span>
                      </b-tooltip>
                    </template>
                  </div>
                </div>
                <div v-else-if="profileData.info.waiver_status == 0" class="border-wrapper  shadow-sm bg_blue bg-white">
                  <div class="border-text mb-1">
                    <h4>Waiver Status</h4>
                    <span class="text-danger"> Not Signed</span>
                  </div>
                  <div class="border-icon">
                    <template>
                      <div class="" id="tooltip2"><i class="fas fa-info-circle"></i></div>
                      <b-tooltip target="tooltip2" class="white">
                        <span v-if="profileData.info.waiver_status ==1"> Signed</span>
                        <span v-if="profileData.info.waiver_status ==0"> Not Signed</span>
                      </b-tooltip>
                    </template>
                  </div>
                </div>
              </div>
              <div v-if="subdomain == 'shooting'" class="mdashicon col-md-12 r-pad pl-0">
                <div class=" bg-ins_prog2 mb-2 shadow-sm">
                  <div class="card-header rm-border">
                    <i class="fas fa-question text-dark"></i>
                    <h3 class="text-dark"> Are you interested in hosting a USAS-sanctioned match? Reach out to <a href="mailto:competitions@usashooting.org">competitions@usashooting.org</a> to request individualized Match Director access to the Events System or ask any questions about the process.</h3>
                  </div>
                </div>
              </div>
              <div v-if="subdomain == 'shooting'" class="col-md-12 r-pad pl-0">
                <a target="_blank" class="" href="https://ems.usashooting.org/event_list">
                  <div class=" bg-ins_prog2 mb-2 shadow-sm">
                    <div class="card-header rm-border">
                      <i class="fas fa-crosshairs text-dark"></i>
                      <h3 class="text-dark">Find out about upcoming USA Shooting events.</h3>
                    </div>
                  </div>
                </a>
              </div>
              <div v-if="subdomain == 'shooting'" class="mdashicon col-md-6 pl-0">
                <a target="_blank" class="" href="https://store.usashooting.org/">
                  <div class="bg-ins_prog1 mb-2 shadow-sm" style="background: #fff;">
                    <div class="card-header rm-border">
                      <i class="fas fa-shopping-cart text-dark"></i>
                      <h3 class="text-dark">Merchandise</h3>
                    </div>
                  </div>
                </a>
              </div>
              <div v-if="subdomain == 'shooting'" class="mdashicon col-md-6 r-pad l-pad">
                <a target="_blank" class="" href="https://www.usashooting.org/donate-20141126072420/donate-20200716163507">
                  <div class="bg-ins_prog1 mb-2 shadow-sm" style="background: #fff;">
                    <div class="card-header rm-border">
                      <i class="fas fa-donate text-dark"></i>
                      <h3 class="text-dark"> Donation</h3>
                    </div>
                  </div>
                </a>
              </div>
              <div v-if="getSiteProps('member.banner_visible')" class="col-md-12 pl-0 l-pad newsandannouncement">
                <div class="col-md-12 pl-0">
                  <div class="itm">
                    <div class="nft_pic">
                      <a target="_blank" :href="this.getSiteProps('member.banner_link')">
                  <span>
                    <span class="nft_pic_info">
                      <div style="width:260px;">
                        <span class="nft_pic_title">{{this.getSiteProps('member.dashboard_title_text')}}</span>
                        <span class="nft_pic_by mt-2 mb-2">{{this.getSiteProps('member.dashboard_content_text')}}</span>
                        <span class="clk_nft">Click Here to Apply!</span>
                        </div>
                    </span>
                  </span>
                        <div class="nft_pic_wrap">
                          <img :src="this.getSiteProps('member.dashboard_banner')" class="lazy img-fluid" alt="">
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 r-pad pl-0 mt-2 " :class="{'gray-out-link': enableMagazine }" v-if="this.prop_dashboardLinks.magazine == true">
                <div class="db-link">
                <router-link class="" to="/member/water-skier-magazine">
                  <div class=" bg-ins_prog2 mb-2 shadow-sm">
                    <div class="card-header rm-border ssprts">
                      <i class="fas fa-book-reader text-dark"></i>
                      <h3 class="text-dark">Water Skier Magazine</h3>
                    </div>
                  </div>
                </router-link>
                </div>
              </div>
              <div class="col-md-6 r-pad l-pad mt-2" v-if="this.prop_dashboardLinks.makedonation == true">
                <router-link class="" to="/member/member-donation">
                  <div class="bg-ins_prog1 mb-2 shadow-sm">
                    <div class="card-header rm-border ssprts">
                      <i class="fas fa-donate text-dark"></i>
                      <h3 class="text-dark">Make a Donation</h3>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col-md-6 pl-0 r-pad l-pad " :class="profileData.info.membership.id == 13 || profileData.info.membership.member_type_id == 5 || profileData.info.membership.member_type_id == 7? 'gray-out-link' : ''" v-if="this.prop_dashboardLinks.instructorcoach == true&&profileData.info.membership.member_type_id != 7">
                <div class="db-link">
                  <router-link class="" to="/member/online-testing">
                    <div class="bg-ins_prog mb-2 shadow-sm">
                      <div class="card-header rm-border ssprts">
                        <i class="fas fa-chalkboard-teacher text-dark"></i>
                        <h3 class="text-dark">Instructor/Coach Programs</h3>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="col-md-6 r-pad l-pad" :class="profileData.info.membership.id == 13 || profileData.info.membership.member_type_id == 5 || profileData.info.membership.member_type_id == 7 ? 'gray-out-link' : ''" v-if="this.prop_dashboardLinks.driverprogram == true&&profileData.info.membership.member_type_id != 7">
                <div class="db-link">
                  <router-link class="" to="/member/drivers-program">
                    <div class="bg-ins_prog1 mb-2 shadow-sm">
                      <div class="card-header rm-border ssprts">
                        <i class="fas fa-dharmachakra text-dark"></i>
                        <h3 class="text-dark">Driver Programs / MVR Review</h3>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="col-md-6 p-sm-0 r-pad l-pad " :class="profileData.info.membership.id == 13 || profileData.info.membership.member_type_id == 5 || profileData.info.membership.member_type_id == 7 ? 'gray-out-link' : ''" v-if="this.prop_dashboardLinks.safesports == true&&profileData.info.membership.member_type_id != 7">
                <div class="db-link">
                  <router-link class="" to="/member/safesports">
                    <div class="bg-ins_prog1 mb-2 shadow-sm">
                      <div class="card-header rm-border ssprts">
                        <i class="fas fa-user-shield text-dark"></i>
                        <h3 class="text-dark">Safe Sport Training / Background Screening</h3>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="col-md-6 r-pad l-pad" :class="profileData.info.membership.id ==13 || profileData.info.membership.member_type_id == 5 || profileData.info.membership.member_type_id == 7 ? 'gray-out-link' : ''" v-if="this.prop_dashboardLinks.myofficials == true&&profileData.info.membership.member_type_id != 7">
                <div class="db-link">
                  <a 
                    v-if="profileData.info.official_dashboard.enable"
                    href="javascript:void(0);"
                    @click="officialPost">
                    <div class="bg-ins_prog1 mb-2  shadow-sm">
                      <div class="card-header rm-border ssprts">
                        <i class="fas fa-star-half-alt text-dark"></i>
                        <h3 class="text-dark">
                          My Official's Dashboard
                        </h3>
                      </div>
                    </div>
                  </a>
                  <router-link
                      v-else
                      class=""
                      to="/member/my-officials-ratings-certifications"
                  >
                    <div class="bg-ins_prog1 mb-2  shadow-sm">
                      <div class="card-header rm-border ssprts">
                        <i class="fas fa-star-half-alt text-dark"></i>
                        <h3 class="text-dark">
                          My Official's Dashboard
                        </h3>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="col-md-6 r-pad pl-0" v-if="this.prop_dashboardLinks.membershidiscount == true">
                <a
                    href="https://usawaterski.perkspot.com/login/!2f!3futm_medium!3demail!26utm_id!3dwelcome!26promotionId!3d"
                    target="_blank"
                >
                  <div class=" bg-ins_prog2 mb-0">
                    <div class="card-header rm-border ssprts ">
                      <i class="fas fa-tag text-dark"></i>
                      <h3 class="text-dark">Membership Discounts</h3>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-6 r-pad l-pad" v-if="this.prop_dashboardLinks.merchandise == true">
                <a href="https://stores.inksoft.com/usawsws/shop/home/" target="_blank">
                  <div class=" bg-ins_prog2 mb-0">
                    <div class="card-header rm-border ssprts">
                      <i class="fas fa-shopping-cart text-dark"></i>
                      <h3 class="text-dark">USA-WSWS Merchandise</h3>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>



          <div id="waiver_status_box_section" class="col-md-12 profile-body r-pad l-pad waiver-status_box" v-if="[2,5,7,13].indexOf(profileData.info.membership.member_type_id) === -1">
            <div class="card" :class="{marginminustop: subdomain == 'shooting'}">
              <div class="card-header p-0">
                <div class="header-title">
                  <div class="mem-header mt-2 mb-2">
                    <h4 style="font-size: 20px !important;">Waiver Status Box</h4>
                  </div>
                </div>

                <div
                    class="modal-btn text-right mt-3 mb-2"
                    v-if="
                    this.profileData.info.waiver_status === 0
                    && this.profileData.info.personal.relation < 2
                    && this.profileData.info.membership.name !== 'Supporting'
                  "
                >
                  <!-- <b-button

                    v-b-modal.signSpouseWaiver
                    variant="primary"
                    style="width: 200px;"
                  >
                    <i class="fas fa-pencil-alt"></i> Sign Your Waiver
                  </b-button> -->
                  <button v-b-modal.signSpouseWaiver
                          variant="primary" class="btn btn-outline-primary savebtn p-2"><i class="fas fa-pencil-alt"></i> Sign Your Waiver</button>
                </div>
                <div class="modal-btn text-right mt-3 mb-2" v-if="this.profileData.info.need_child_waiver_sign">
                  <button v-b-modal.signChildWaiver variant="primary" class="btn btn-outline-primary savebtn p-2">
                    <i class="fas fa-pencil-alt"></i> Sign Your Children Waiver
                  </button>
                </div>
              </div>
              <div class="card-body p-0 table-responsive">
                <b-table
                    id="my-table"
                    :items="profileData.info.waiver"
                    :fields="tblWaiverFields"
                    hover
                    show-empty
                >
                  <template :fields="items">
                    <div class="text-left py-0 align-middle">
                      <div class="btn-group btn-group-sm">
                        <button class="btn btn-info">
                          <i class="fas fa-eye"></i>
                        </button>
                        <button class="btn btn-primary ml-1">
                          <i class="fas fa-pencil-alt"></i>
                        </button>
                        <button class="btn btn-danger ml-1">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </template>
                  <template #empty="scope">
                    <h4>{{ scope.emptyText }}</h4>
                  </template>
                  <template #cell(waivers_id)="row">
                    {{ getWaiverName(row.item.waivers_id) }}
                  </template>
                  <template #cell(initials)="row">
                    {{ row.item.initials != "" ? "Signed" : "Not Signed" }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <b-modal
              id="signSpouseWaiver"
              title="Sign your waivers"
              scrollable
              size="xl"
              hide-footer
          >
            <b-card no-body>
              <b-tabs v-model="tabIndex" pills card id="signSpouseWaiverCard">
                <b-tab
                    v-for="(spsWaiver, idx) in spouseWaiverForModal"
                    :key="idx"
                    :title="spsWaiver.waivers_title"
                >
                  <div class="text-center">
                    <div>
                      <i>This waiver is for your membership effective from </i>
                      <b>{{ currentDate }}</b> <i>to </i>
                      <b>{{ spsWaiver.user_info[0].expires_at }}</b>
                    </div>
                    <div>
                      <i>Member name</i>:
                      <b>{{ spsWaiver.user_info[0].member_name }}</b>
                    </div>
                  </div>
                  <p v-html="spsWaiver.waivers_content"></p>
                  <div class="form-inline">
                    <div v-for="(chld, chldId) in spsWaiver.user_info" :key="chldId" class="mb-1">
                      <b-form-checkbox :id="'spouseWaiverCheck-'+(idx+chldId)" @change="markWaiverSign($event,idx+chldId)" value="1" unchecked-value="0" >
                        <b-form-input v-model="waiverData[(idx+chldId)].member_initials" size="sm" maxlength="2" style="width: 40px;" ></b-form-input>
                        I,
                        <span v-if="waiverData[(idx+chldId)].ask_name==1"><b-form-input v-model="waiverData[(idx+chldId)].signed_member" size="sm" maxlength="50"></b-form-input></span>
                        <span v-else>{{ waiverData[(idx+chldId)].signed_member }}</span>
                        , accept the above waiver for {{ waiverData[(idx+chldId)].member_name }} on this date:
                        <b-form-input v-model="waiverCurrentDtTime" size="sm" disabled></b-form-input>
                      </b-form-checkbox>
                    </div>
                  </div>
                  <p class="font-13 mt-4 text-danger"><em>Please check the box and initial in the space provided.</em></p>
                  <span class="text-sm text-danger">{{ waiverErrors.agree }}</span>
                  <span class="text-sm text-danger">{{ waiverErrors.initials }}</span>
                </b-tab>
              </b-tabs>
              <div class="text-right col-sm-12">
                <b-button-group class="mt-2 mb-2">
                  <b-button variant="info" @click="previousWaiver" v-if="tabIndex !== 0">Previous</b-button>
                  <b-button variant="info" @click="spouseWaiverSubmit(0)" v-if="tabIndex == (waiverLength-1)">Sign Now</b-button>
                  <b-button variant="info" @click="nextWaiver" v-else>Next</b-button>
                </b-button-group>
              </div>
            </b-card>
          </b-modal>

          <b-modal
              id="signChildWaiver"
              title="Sign waiver for your children"
              scrollable
              size="xl"
              hide-footer
          >
            <b-card no-body>
              <b-tabs v-model="tabIndex" pills card id="signChildWaiverCard">
                <b-tab
                    v-for="(chldWaiver, idx) in childWaiverForModal"
                    :key="idx"
                    :title="chldWaiver.waivers_title"
                >
                  <div class="text-center">
                    <div>
                      <b>This waiver is for your membership effective from </b>
                      <b>{{ currentDate }}</b> <i>to </i>
                      <b>{{ chldWaiver.user_info[0].expires_at }}</b>
                    </div>
                  </div>
                  <p v-html="chldWaiver.waivers_content"></p>
                  <div class="form-inline">
                    <div v-for="(chld, chldId) in chldWaiver.user_info" :key="chldId" class="mb-3">
                      <b-form-checkbox v-model="waiverData[(idx+chldId)].agree" value="1" unchecked-value="0" >
                        <b-form-input v-model="waiverData[(idx+chldId)].member_initials" size="sm" maxlength="2" style="width: 40px; margin-right: 5px" ></b-form-input>
                        I,
                        <span v-if="waiverData[(idx+chldId)].ask_name==1"><b-form-input v-model="waiverData[(idx+chldId)].signed_member" size="sm" maxlength="50"></b-form-input></span>
                        <span v-else>{{ waiverData[(idx+chldId)].signed_member }}</span>
                        , accept the above waiver for <b class="ml-1 mr-1">{{ waiverData[(idx+chldId)].member_name }}</b> on this date:
                        <b-form-input v-model="waiverCurrentDtTime" size="sm" disabled style="margin-left: 5px;"></b-form-input>
                      </b-form-checkbox>
                    </div>
                  </div>
                  <span class="text-sm text-danger">{{ waiverErrors.agree }}</span>
                  <span class="text-sm text-danger">{{ waiverErrors.initials }}</span>
                </b-tab>
              </b-tabs>
              <div class="text-right col-sm-12">
                <b-button-group class="mt-2 mb-2">
                  <b-button variant="info" @click="childWaiverSubmit()">Sign Now</b-button>
                </b-button-group>
              </div>
            </b-card>
          </b-modal>

          <b-modal
              id="confirm-modal"
              title="Confirmation"
              @hide="resetRenewConfirmation"
          >
            <div class="row">
              <div class="col-md-12" v-if="!renewConfirmation && subdomain != 'shooting' && this.canUpgrade">
                <label>Please choose Renew or Upgrade membership</label>
                <b-form-radio-group
                    label="Please Choose Renewal or Upgrade Membership"
                    id="btn-radios-2"
                    hide-footer
                    v-model="renewData"
                    :options="options"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    size="md"
                    name="radio-btn-outline"
                    buttons
                ></b-form-radio-group>
                <div class="form-check-label">
                  <ul class="grassrootul" v-if="renewData === 'renew' && renewUpgradeMessages.renew">
                    <li v-for="(message, index) in renewUpgradeMessages.renew" :key="index"><label class="form-check-label" v-html="message"></label></li>
                  </ul>
                  <ul class="grassrootul" v-if="renewData === 'upgrade' && renewUpgradeMessages.upgrade">
                    <li v-for="(message, index) in renewUpgradeMessages.upgrade" :key="index"><label class="form-check-label" v-html="message"></label></li>
                  </ul>
                </div>
              </div>
              <div v-else>
                <div class="form-check">
                  <input type="checkbox" v-model="renewCheck" class="form-check-input" id="renewCheck">
                  <label class="form-check-label" for="renewCheck" v-if="subdomain === 'alliancefastpitch'">Yes, please renew my membership for the {{ renewSeasonYearText }} season.</label>
                  <label class="form-check-label" for="renewCheck" v-else-if="profileData.info.membership.member_type_id == 7 && campskiRenewConfirmation">{{campskiRenewConfirmation.title}}</label>
                  <label class="form-check-label" for="renewCheck" v-else>Yes, please renew my membership for an additional 12 months.</label>
                  <ul class="grassrootul" v-if="profileData.info.membership.member_type_id == 7 && campskiRenewConfirmation">
                    <li  v-for="(message, index) in campskiRenewConfirmation.content" :key="index"><i  class="fas fa-chevron-right"></i>{{ message }}</li>
                  </ul>
                  <ul class="grassrootul" v-else-if="renewConfirmationMessages">
                    <li  v-for="(message, index) in renewConfirmationMessages" :key="index"><i  class="fas fa-chevron-right"></i>{{ message }}</li>
                  </ul>
                  <span id="confirmation_alert"></span>
                </div>
              </div>
            </div>
            <template #modal-footer="{ ok, cancel}">
              <b-button variant="secondary" @click="cancel()">
                Cancel
              </b-button>
              <b-button variant="primary"  @click="handleRenewConfirmation">
                Continue
              </b-button>
            </template>
          </b-modal>

          <b-modal id="upgrade-confirm" title="Confirmation" @hide="resetRenewConfirmation" v-if="canUpgrade && !membershipExpiring">
            <div class="row">
              <div class="form-check">
                <input type="checkbox" v-model="upgradeCheck" class="form-check-input" id="upgradeCheck">
                <label class="form-check-label" for="upgradeCheck">Yes, please upgrade my membership.</label>
              </div>
              <ul class="grassrootul" v-if="renewUpgradeMessages.upgrade">
                <li v-for="(message, index) in renewUpgradeMessages.upgrade" :key="index"><label class="form-check-label" v-html="message"></label></li>
              </ul>
              <span id="upgrade_confirmation_alert"></span>
            </div>
            <template #modal-footer="{ ok, cancel}">
              <b-button variant="secondary" @click="cancel()">
                Cancel
              </b-button>
              <b-button variant="primary"  @click="handleUpgradeConfirmation">
                Continue
              </b-button>
            </template>
          </b-modal>
        </div>
      </div>
    </div>
    <div class="pb-4"></div>
    <dashboardfooter></dashboardfooter>
  </div>
</template>

<script>
import axios from "axios";
import AutoRenewalButton from "../../admin/components/AutoRenewalButton";
import CustomAlert from "../../CustomAlert";
import * as $ from "jquery";
import moment from "moment";
import { EventBus } from '@/event-bus';
export default {
  name: "memberDashboard",
  components: { CustomAlert,AutoRenewalButton },
  data() {
    return {
      renewSeasonYearText: '',
      displayMissingMemFields: false,
      prop_dashboardLinks: null,
      dashboard_header: {},
      renewalUpgradeText:'Renew/Upgrade Membership',
      canUpgrade:true,
      membershipExpiring:true,
      getError:false,
      prop_footer: {},
      renewData: "renew",
      digitalInfoView:true,
      autoRenewalModalOpen: false,
      autoRenew:0,
      page:'dashboard',
      renewCheck: false,
      upgradeCheck: false,
      renewConfirmation: false,
      options: [
        { text: "Renew membership", value: "renew" },
        { text: "Upgrade Membership", value: "upgrade" },
      ],
      profileData: {
        info: [],
      },
      autoRenewData:{
        regId:"",
        status:"",
      },
      cardError: {},
      tblWaiverFields: [
        { key: "title", sortable: true, label: "Waiver Name" },
        { key: "pivot.initials", sortable: false, label: "Initials" },
        { key: "pivot.signed_for", sortable: true, label: "Signed For" },
        { key: "pivot.signed_user", sortable: true, label: "Signed By" },
        { key: "pivot.signed_at", sortable: false, label: "Signed At", formatter: "usdate" },
      ],
      spouseWaiverForModal: [],
      childWaiverForModal: [],
      tabIndex: 0,
      waiverLength: 0,
      waiverData: [],
      waiverErrors: {
        agree: "",
        initials: "",
      },
      waiverCurrentDtTime: "",
      ratingData:[],
      personData:[],
      currentDate: '',
      showLoader:true,
      safeSportApiCall: false,
      safeSportRefreshButton: '',
      isCurrentyear:"",
      downloading: {
        ratings: false,
        certs: false,
        events: false
      },
      dashboardWelcomeContent:[],
      dashboardBannerContent:[],
      dashboardBannerStatus:false,
      dashboardWelcomeStatus:false,
      linkToPage: '',
      viewRatingLoader: false,
      detailsData: null
    };
  },
  methods: {
    officialPost() {
      let official_dashboard = this.profileData?.info?.official_dashboard;
      let link = official_dashboard?.url;
      var form = document.createElement("form");
      form.method = "GET";
      form.action = link;
      form.target = "_blank";
      var memberIdElement = document.createElement("input");
      memberIdElement.type = "hidden";
      memberIdElement.value = this.profileData?.info?.confirmation_code;
      memberIdElement.name = "MemberId";
      form.appendChild(memberIdElement);
      var DashboardPasskeyEl = document.createElement("input");
      DashboardPasskeyEl.type = "hidden";
      DashboardPasskeyEl.value = official_dashboard?.key
      DashboardPasskeyEl.name = "DashboardPasskey";
      form.appendChild(DashboardPasskeyEl);
      var DashboardTargetEl = document.createElement("input");
      DashboardTargetEl.type = "hidden";
      DashboardTargetEl.value = official_dashboard?.target
      DashboardTargetEl.name = "DashboardTarget";
      form.appendChild(DashboardTargetEl);
      document.body.appendChild(form);
      form.submit();
    },
    splitter(value){
      let val = value.split('of');
      return val[1];
    },
    markWaiverSign(checked, index){
      this.waiverData[index].agree = checked;
    },
    renewMemberShip: function() {
      if(this.membershipExpiring){
        this.$bvModal.show("confirm-modal");
      }else{
        this.renewData = "upgrade";
        this.$bvModal.show("upgrade-confirm");
      }
    },
    handleRenewConfirmation: function() {
      if(this.renewData == 'renew') {
        this.renewConfirmation = true;
        if(this.renewCheck){
          if(this.subdomain === 'alliancefastpitch') {
            window.open("/member/renewal", "_self");
          } else if (this.profileData?.info?.membership?.member_type_id === 7) {
            this.$router.push("/member/campski-renewal");
          } else {
            window.open("/member/" + this.renewData, "_self");
          }
        }else{
          $('#confirmation_alert').html("<p style='color:red;font-size:13px'>Please check the box</p>");
        }
      }
      if (this.renewData == "upgrade") {
        window.open("/member/" + this.renewData, "_self");
      }
    },
    handleUpgradeConfirmation(){
      if(this.upgradeCheck){
        window.open("/member/" + this.renewData, "_self");
      } else {
        $('#upgrade_confirmation_alert').html("<p style='color:red;font-size:13px'>Please check the box</p>");
      }
    },
    resetRenewConfirmation:function()
    {
      this.renewData = 'renew';
      this.renewConfirmation = false;
      this.renewCheck = false;
      this.upgradeCheck = false;
    },
    loadMembersInfo() {
      axios
          .get(this.basePath + "api/member/my_profile", {
            headers: this.memberHeaders,
          })
          .then((response) => {
            if(!this.getSiteProps('general.member_profile_addition_info') && this.getSiteProps('general.member_profile_addition_info') != undefined){
              this.digitalInfoView = false;
            }
            this.profileData.info = response.data.data;
            this.autoRenew = response.data.data.auto_renew;
            this.autoRenewData.regId = response.data.data.registration[0].id;
            this.autoRenewData.status = response.data.data.auto_renew;
            if(this.subdomain == "shooting")
            {
              this.page = "Shooting Dashboard";
            }
            EventBus.$emit('getGroupCommittee', response.data.data.groupCommittee);
            this.membershipExpiring = this.profileData.info.membership_expiring;
            this.canUpgrade = this.profileData.info.canUpgrade;
            this.renewalUpgradeText = (!this.membershipExpiring)? 'Upgrade Membership':'Renew/Upgrade Membership';
            this.renewalUpgradeText = (this.canUpgrade)? this.renewalUpgradeText:'Renew Membership';
            this.renewalUpgradeText = (this.subdomain=='waterski'&&this.profileData.info.membership.id == 13)? 'Upgrade Membership' :this.renewalUpgradeText;
            if(!this.canUpgrade){
              this.renewConfirmation = true;
            }
            if (this.profileData.info.waiver_status === 0
                && response.data.data.signWaiver && this.subdomain != 'alliancefastpitch') {
              axios.get(
                  this.basePath + "api/member/get_spouse_waiver/" + this.profileData.info.registration[0]['id'],
                  { headers: this.memberHeaders }
              ).then((resp) => {
                this.spouseWaiverForModal = resp.data.data;
                let list = [];
                let waiverUser = [];
                let i=0;
                $.each(this.spouseWaiverForModal, function(idx, value) {
                  let waiverId = value.waivers_id;
                  $.each(value.user_info, function(key, info){
                    list = info;
                    list.agree = 0;
                    list.waivers_id = waiverId;
                    waiverUser[i++] = list;
                  });
                });
                this.waiverData = waiverUser;
                this.waiverLength = this.spouseWaiverForModal.length;
              }).catch((err) => {
                console.log("Spouse waiver error");
              });
              if (!this.profileData.info.waiver_status) {
                this.$nextTick(() => { this.$bvModal.show("signSpouseWaiver"); });
              }
            }
            if(this.profileData.info.id!='' && this.profileData?.info?.membership?.member_type_id !== 7 && this.subdomain === "waterski"){
              axios.get(this.basePath + 'api/member/officialratings/'+this.profileData.info.id, {headers: this.memberHeaders})
                  .then(function (response) {
                    if(response.data.status!='error') {
                      const resp = response.data.data;
                      if(response.data.message!="Unauthorized parameter UserId from this token"){
                        this.ratingData = resp.rating;
                        this.certsData = resp.certs;
                        this.personData = resp.personInfo;
                        this.eventsData = resp.events;
                      }
                      else{
                        this.getError = true;
                      }
                    }else{
                      this.personData.Email = response.data.message;
                    }
                    this.showLoader=false;
                  }.bind(this))
                  .catch(function (error) {
                    console.log(error);
                  });
            }

            this.autoRefreshSafeSport(); // Auto Refresh safe sport

            if (this.profileData.info.need_child_waiver_sign) {
              axios.get(
                  this.basePath + "api/member/get_children_waiver/" + this.profileData.info.registration[0]['id'],
                  { headers: this.memberHeaders }
              ).then((resp) => {
                this.childWaiverForModal = resp.data.data;
                let list = [];
                let waiverUser = [];
                let i=0;
                $.each(this.childWaiverForModal, function(idx, value) {
                  let waiverId = value.waivers_id;
                  $.each(value.user_info, function(key, info){
                    list = info;
                    list.agree = 0;
                    list.waivers_id = waiverId;
                    waiverUser[i++] = list;
                  });
                });
                this.waiverData = waiverUser;
                this.waiverLength = this.childWaiverForModal.length;
              }).catch((err) => {
                console.log("Child waiver error");
              });
              this.$nextTick(() => { this.$bvModal.show("signChildWaiver"); });
            }
            if(this.subdomain == "shooting"&&this.profileData.info.membership.member_type_id !=7){
              if(this.profileData.info.personal.cmp_no == null && this.profileData.info.personal.nra_no == null &&
                  this.profileData.info.personal.sasp_no == null && this.profileData.info.personal.sctp_no == null){
                this.displayMissingMemFields = true;
                this.alertMessage = "Please fill out the CMP, NRA, SASP, SCTP Membership ID's";
              }
            }
            this.renewSeasonYearText = this.profileData.info.renew_season_year_text;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    autoRefreshSafeSport(){
      if(
          this.profileData.info.safe_sport != null &&
          (
              [1,13].indexOf(this.profileData.info.safe_sport.safe_sport_status) !== -1 ||
              (
                  this.profileData.info.safe_sport.safe_sport_status === 3 &&
                  moment(this.profileData.info.safe_sport.expiration, "MM/DD/YYYY").isBefore(new Date())
              )
          ) &&
          this.safeSportApiCall === false
      ) {
        this.getSafeSportUserApi();
      } else {
        this.safeSportApiCall = true;
      }
    },
    getSafeSportUserApi() {
      this.safeSportRefreshButton = 'Processing...';
      axios.get(this.basePath+"api/member/safeSport",{ headers:this.memberHeaders })
          .then((res) => {
            this.safeSportApiCall = true;
            this.loadMembersInfo();
            return res;
          })
          .catch((error) => {
            console.log('Error:'+ error);
            this.safeSportRefreshButton = 'Refresh';
            return false;
            // error.response.status Check status code
          }).finally(() => {
      });
    },
    getWaiverName(id) {
      for (const waiver in this.profileData.info.registration.waivers) {
        if (this.profileData.info.registration.waivers[waiver].id == id) {
          return this.profileData.info.registration.waivers[waiver].title;
        }
      }
    },
    nextWaiver() {
      if (this.validateWaiverSign(0)) {
        this.tabIndex++;
        document.getElementById("signSpouseWaiverCard").scrollIntoView();
      }
    },
    previousWaiver() {
      this.tabIndex--;
      this.waiverErrors.agree = "";
      this.waiverErrors.initials = "";
      document.getElementById("signSpouseWaiverCard").scrollIntoView();
    },
    spouseWaiverSubmit(checkAll=0) {
      this.waiverErrors.agree = "";
      this.waiverErrors.initials = "";
      if (this.validateWaiverSign(checkAll)) {
        axios
            .post(
                this.basePath +
                "api/member/update_spouse_waiver/" +
                this.profileData.info.registration[0]['id'],
                this.waiverData,
                { headers: this.memberHeaders }
            )
            .then((response) => {
              if (response.data.status == "success") {
                this.$bvModal.hide("signSpouseWaiver");
                this.alertMessage = "Waiver signed successfully";
                this.displayAlert = true;
              }
              this.loadMembersInfo();
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    childWaiverSubmit(){
      this.waiverErrors.agree = "";
      this.waiverErrors.initials = "";
      if (this.validateWaiverSign(1)) {
        axios
            .post(
                this.basePath +
                "api/member/update_child_waiver/" +
                this.profileData.info.registration[0]['id'],
                this.waiverData,
                { headers: this.memberHeaders }
            )
            .then((response) => {
              if (response.data.status == "success") {
                this.$bvModal.hide("signChildWaiver");
                this.alertMessage = "Waiver signed successfully";
                this.displayAlert = true;
              }
              this.loadMembersInfo();
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    validateWaiverSign(checkAll) {
      if(checkAll===1){
        let valid='';
        let agreeTotal=0;
        let initTotal=0;
        $.each(this.waiverData, function(idx, value) {
          let agree = (value.agree == 1);
          let initials = (value.member_initials != "");
          agreeTotal = agreeTotal+(agree?0:1);
          initTotal = initTotal+(initials?0:1);
          valid+=(agree && initials ? 1 : 0);
        });
        this.waiverErrors.agree = (agreeTotal>0 ? "Please acknowledge by checking the box":"");
        this.waiverErrors.initials = (initTotal>0 ? "You must enter two letters to initial":"");
        console.log(valid);
        return (valid.indexOf('0')==-1);
      }else {
        let agree = $('#spouseWaiverCheck-' + this.tabIndex).is(":checked");
        let initials = (this.waiverData[this.tabIndex].member_initials != "");
        this.waiverErrors.agree = (agree ? "" : "Please acknowledge by checking the box");
        this.waiverErrors.initials = (initials ? "" : "You must enter two letters to initial");
        return agree && initials;
      }
    },
    chkDateExp(value){
      let expDt = moment(value);
      if(value == null) {
        return "N/A";
      }else if(moment().isAfter(expDt)){
        return '<span class="text-danger">'+expDt.format("MM/DD/YYYY")+'</span>';
      }else{
        return expDt.format("MM/DD/YYYY");
      }
    },
    formatDateTime(value){
      return moment(value).format("MM/DD/YYYY");
    },
    memberWelcomeContents() {
      axios.get(this.basePath+'api/cmsSection/'+1)
          .then(function (response) {
            response.data.data.forEach(content => {
              if (content.section_id == 1) {
                this.dashboardWelcomeContent = content;
                this.dashboardWelcomeStatus = true;
              } else if (content.section_id == 6) {
                this.dashboardBannerContent = content;
                this.linkToPage = content.link;
                this.dashboardBannerStatus = true;
              }
            });
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
    },
    getCurrentDate() {
      const today = moment().format('MM/DD/YYYY');
      this.currentDate = today;
    }
  },
  updated(){
    this.prop_dashboardLinks = this.getSiteProps('memberdashboard.links');
    this.prop_footer = this.getSiteProps('memberRegistration.footer');
    this.dashboard_header = this.getSiteProps('memberdashboardbanner');
  },
  mounted() {
    this.loadMembersInfo();
    this.memberWelcomeContents();
    this.getCurrentDate();
    this.waiverCurrentDtTime = new Date().toLocaleString();
    this.isCurrentyear = new Date();
  },
  computed: {
    renewUpgradeMessages(){
      return this.getSiteProps('memberdashboard.renewUpgrade.message');
    },
    enableMagazine(){
      return this.profileData?.info?.membership?.id == 7 || this.profileData?.info?.membership?.id == 13 || (this.profileData?.info?.membership?.id == 5 && this.profileData?.info?.personal_details?.relation != 0);
    },
    renewConfirmationMessages(){
      return this.getSiteProps('renewConfirmation.member');
    },
    campskiRenewConfirmation(){
      return this.getSiteProps('campskiRenewConfirmation');
    },
  }
};
</script>
<style>
.page-link{
  color: #000 !important;
}
.page-item.active .page-link{
  background-color: #002c59!important;
  border-color: #002c59!important;
  color: #fff !important;
}
.card-img{
  height: 200px !important;
  object-fit: none;
}
</style>